module.exports = __webpack_public_path__ + "static/lights32-f534522f35164f0bfe9ca9fe3603b411.jpg";